export const personasConstants = {
    SHOW_RELATIVES: 'SHOW_RELATIVES',
    UPDATE_IMAGE_PROFILE: 'UPDATE_IMAGE_PROFILE',
    UPDATE_RELATIVE: 'UPDATE_RELATIVE',
    UPDATE_USER_PROFILE: 'UPDATE_USER_PROFILE',
    UPDATE_PERSONA: 'UPDATE_PERSONA',
    UPDATE_MY_RELATIVES: 'UPDATE_MY_RELATIVES',
    SHOW_PERSONA: 'SHOW_PERSONA',
    REMOVE_RELATED: 'REMOVE_RELATED',
    ADD_RELATED: 'ADD_RELATED'
}